import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "icon-cross" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message", _ctx.color ? `message--${_ctx.color}` : '']),
    role: "alert",
    "data-test": "div-alertMessage"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.showClose)
      ? (_openBlock(), _createBlock(_component_Btn, {
          key: 0,
          onClick: _ctx.click,
          class: "message__close",
          ghost: "",
          title: "Close"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 2))
}